// extracted by mini-css-extract-plugin
export default {"radioContainer":"zI5rrr","boldText":"wSNmeb"};